import { defineEvent } from '../types/event';
export var SORT_OPTION_SELECT = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Sort_option_selected'
        }
    ]
});
